import React, { Component } from "react";
import Cookies from "js-cookie";
import { Helmet } from "react-helmet";
import axios from "axios";
import { Link } from "react-router-dom";

import Wrapper from "../../Components/Container";

import styles from "./style.module.scss";

class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bonus: 0,
      balance: 0,
      today: "",
      username: "",
    };
  }

  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  componentDidMount() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();
    today = mm + "/" + dd + "/" + yyyy;

    if (!Cookies.get("_lab__topup")) return this.props.history.push("/login");
    const api = `${process.env.REACT_APP_BACKEND_URI}/getUserInfo/balance`;
    const token = Cookies.get("_lab__topup");
    axios
      .get(api, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        const refUrl =
          this.state.refUrl +
          res.data.userName[0].toUpperCase() +
          res.data.userName.slice(1);
        this.setState({
          bonus: this.numberWithCommas(res.data.bonus),
          balance: this.numberWithCommas(res.data.balance),
          today,
          refUrl,
          username: res.data.userName,
        });
      });
  }

  render() {
    return (
      <Wrapper>
        <Helmet>
          <title>TOP UP LAB | DASHBOARD </title>
        </Helmet>
        <div className={styles.balances}>
          <div>
            <h2>It's Over</h2>
            <h1>Thanks</h1>
          </div>
          <div>
            <h2>Balance</h2>
            <h1>₦ {this.state.balance}</h1>
          </div>
        </div>
        <div className={[styles.card, styles.refLink].join(" ")}>
          <marquee>We're sorry we won't be able to help anymore, Kindly help withdraw your money even if its ₦1. Thanks for the time with us.</marquee>
        </div>
        <div className={styles.cards}>
          <Link to="/withdraw">
            <div>WITHDRAW BALANCE</div>
          </Link>
          <Link to="/history">
            <div>TRANSACTIONS</div>
          </Link>
          <a
            href="https://api.whatsapp.com/send?phone=2347016412041&text=Hi%Support%20TopUpLab.Tell%20me%20more%20about%20your%20product%20"
            target="_blank"
            rel="noreferrer"
            style={{ backgroundColor: "#3598DB", color: "white" }}
          >
            <div>CHAT ADMIN</div>
          </a>
        </div>
      </Wrapper>
    );
  }
}

export default index;
